__webpack_require__.p = "https://www.bcnindia.com/";